// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","flag":"Card_flag__U3F1j","textContainer":"Card_textContainer__0Yeng","text":"Card_text__weAU8"};